import styled from 'styled-components';

export const StyledMachineDetailsPanel = styled.div`
  min-height: inherit;
  height: 100%;

  .loading-wrapper {
    height: calc(100vh - 294px);
  }
`;
